<!--
 * @Description: 新闻中心列表
 * @Author: mileS
 * @Date: 2019-08-07 10:14:46
 * @LastEditTime: 2020-06-10 16:38:16
 * @LastEditors: mileS
 -->
<template>
  <div class="download_center_container">
    <div class="section part1">
      <div class="row">
        <ul class="news_list">
          <li v-for="(item,index) in newsList" :key="index" @click="showDetail(item.id)" class="news_item">
            <div class="news_item_left">
              <img :src="item.pic" class="new_theme_img" alt />
            </div>
            <div class="news_item_right">
              <div class="title">{{ item.title}}</div>
              <div class="content">
                {{ item.content }}
                <span class="read-detail">查看详情<span class="el-icon-arrow-right"></span></span>
              </div>
              <div class="bottom">
                {{ item.platform }}
                <span class="time">{{item.time}}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import headBanner from '@/components/global/headBanner'
import mHeadBanner from '@/components/global/mHeadBanner'
import { newsData } from './assets/data'
export default {
  // mixins: [mixinName],
  components: { headBanner, mHeadBanner },
  data () {
    return {
      key: 'value',
      newsList: newsData
    }
  },
  created () {
    this.goTo(1)
  },
  computed: {
    name () {
      return this.key
    }
  },
  methods: {
    goTo (target) {
      console.log(target)
      // var scrollT = document.body.scrollTop|| document.documentElement.scrollTop
      // if (scrollT >target) {
      //   var timer = setInterval(function(){
      //     var scrollT = document.body.scrollTop|| document.documentElement.scrollTop
      //     var step = Math.floor(-scrollT/6)
      //     document.documentElement.scrollTop = document.body.scrollTop = step + scrollT
      //     if(scrollT <= target){
      //       document.body.scrollTop = document.documentElement.scrollTop = target
      //       clearTimeout(timer)
      //     }
      //   },20)
      // }else if(scrollT == 0){
      //   var timer = setInterval(function(){
      //     var scrollT = document.body.scrollTop|| document.documentElement.scrollTop
      //     var step = Math.floor(300/3*0.7)
      //     document.documentElement.scrollTop = document.body.scrollTop = step + scrollT
      //     console.log(scrollT)
      //     if(scrollT >= target){
      //       document.body.scrollTop = document.documentElement.scrollTop = target
      //       clearTimeout(timer)
      //     }
      //   },20)
      // }else if(scrollT < target){
      //   var timer = setInterval(function(){
      //     var scrollT = document.body.scrollTop|| document.documentElement.scrollTop
      //     var step = Math.floor(scrollT/6)
      //     document.documentElement.scrollTop = document.body.scrollTop = step + scrollT
      //     if(scrollT >= target){
      //       document.body.scrollTop = document.documentElement.scrollTop = target
      //       clearTimeout(timer)
      //     }
      //   },20)
      // }else if(target == scrollT){
      //   return false
      // }
    },

    /**
     * @Desc 查看详情
     * @params {Number}
     * */
    showDetail (id) {
      this.$router.push(`/about_us/news_center/detail?id=${id}`)
    }
  }
}
</script>

<style scoped lang="scss">
.download_center_container {
  .row {
    padding-top: 110px;
    text-align: left;
    background-color: #F8F9FD;
    .news_list {
      margin: 0 auto 30px auto;
      width: 1106px;
      padding: 30px 0 20px 0;
      background: #FFFFFF;
      .news_item {
        margin-bottom: 50px;
        padding: 0 50px;
        display: flex;
        cursor: pointer;
        .news_item_left {
          .new_theme_img {
            width:212px;
            height:130px;
            border-radius:4px;
          }
        }
        .news_item_right {
          color: black;
          flex: 1;
          margin-left: 40px;
          .title {
            font-size: 22px;
            font-weight: 600;
            color: rgba(40,40,40,1);
            line-height: 30px;
          }
          .content {
            margin-top: 10px;
            font-size:16px;
            font-weight:400;
            color:rgba(40,40,40,1);
            line-height:22px;
            /*overflow: hidden;*/
            /*text-overflow: ellipsis;*/
            /*display: -webkit-box;*/
            /*-webkit-line-clamp: 2;*/
            /*line-clamp: 2;*/
            /*-webkit-box-orient: vertical;*/
            .read-detail{
              margin-left: 10px;
              margin-top: 26px;
              color: #999999;
            }
          }
          .bottom {
            margin-top: vw(42);
            display: flex;
            justify-content: left;
            font-size:14px;
            font-weight:400;
            color:rgba(40,40,40,1);
            line-height:20px;
            .time {
              margin-left: 10px;
            }
            a:visited {
              background: #00ff00;
            }
          }
        }
      }
    }
  }
}
</style>
